import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ActivityTimeAvailability from './activity-time-availability';
import ActivityTimeAvailabilityDetail from './activity-time-availability-detail';
import ActivityTimeAvailabilityUpdate from './activity-time-availability-update';
import ActivityTimeAvailabilityDeleteDialog from './activity-time-availability-delete-dialog';

const ActivityTimeAvailabilityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ActivityTimeAvailability />} />
    <Route path="new" element={<ActivityTimeAvailabilityUpdate />} />
    <Route path=":id">
      <Route index element={<ActivityTimeAvailabilityDetail />} />
      <Route path="edit" element={<ActivityTimeAvailabilityUpdate />} />
      <Route path="delete" element={<ActivityTimeAvailabilityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ActivityTimeAvailabilityRoutes;
